import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgKeyGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color} opacity={0.4}>
      <path d='M15.25 7.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M10.707 12.207a1 1 0 0 0-1.414-1.414l-5.5 5.5a1 1 0 0 0-.274.903l.5 2.5A1 1 0 0 0 5 20.5h2.5a1 1 0 0 0 .832-.445l1.703-2.555H11.5a1 1 0 0 0 .832-.445l1.667-2.5a1 1 0 1 0-1.664-1.11l-1.37 2.055H9.5a1 1 0 0 0-.832.445L6.965 18.5H5.82l-.234-1.171z' />
    </g>
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10.69 4.19C12.02 2.86 13.546 2 15.25 2s3.23.86 4.56 2.19S22 7.045 22 8.75s-.86 3.23-2.19 4.56-2.855 2.19-4.56 2.19-3.23-.86-4.56-2.19S8.5 10.455 8.5 8.75c0-1.705.86-3.23 2.19-4.56M15.25 4c-.986 0-2.033.49-3.146 1.604C10.99 6.717 10.5 7.764 10.5 8.75s.49 2.033 1.604 3.146c1.113 1.113 2.16 1.604 3.146 1.604s2.033-.49 3.146-1.604C19.51 10.783 20 9.736 20 8.75s-.49-2.033-1.604-3.146C17.283 4.49 16.236 4 15.25 4'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgKeyGhostLine)
export default ForwardRef
